import type { Song } from "../types";

/** Row, Row, Row Your Boat (traditional, public domain). */
export const rowYourBoat: Song = {
  id: "row-your-boat",
  title: "Row, Row, Row Your Boat",
  bpm: 100,
  instrument: "piano",
  notes: [
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 0.75 },
    { key: "D4", beats: 0.25 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 0.75 },
    { key: "D4", beats: 0.25 },
    { key: "E4", beats: 0.75 },
    { key: "F4", beats: 0.25 },
    { key: "G4", beats: 2 },
    { key: "C5", beats: 0.33 },
    { key: "C5", beats: 0.33 },
    { key: "C5", beats: 0.34 },
    { key: "G4", beats: 0.33 },
    { key: "G4", beats: 0.33 },
    { key: "G4", beats: 0.34 },
    { key: "E4", beats: 0.33 },
    { key: "E4", beats: 0.33 },
    { key: "E4", beats: 0.34 },
    { key: "C4", beats: 0.33 },
    { key: "C4", beats: 0.33 },
    { key: "C4", beats: 0.34 },
    { key: "G4", beats: 0.75 },
    { key: "F4", beats: 0.25 },
    { key: "E4", beats: 0.75 },
    { key: "D4", beats: 0.25 },
    { key: "C4", beats: 2 },
  ],
};
